<div class="max-h-[80vh] w-full px-4">
  @if (!id()) {
    <!-- Show title only on legacy modals that use the observable -->
    <h2 class="text-xl font-semibold mt-1 pb-1 w-full">
      {{ '#WWS_CORE.COMMANDS.ARTIKELINFO.NAME' | translate }}
    </h2>
  }

  <div class="overflow-y-auto max-h-[70vh] pb-2 overflow-x-hidden">
    <ng-container *ngComponentOutlet="modalComponent; inputs: inputs()"></ng-container>
  </div>
</div>
